<template>
  <div class="login">
    <div class="login-wrapper">
      <img :src="require('@/assets/images/logo_sas_portrait.svg')" />
      <h1>Use suas informações para autenticar</h1>
      <input type="email"
             ref="email"
             placeholder="E-mail"
             name="email"
             v-on:keypress="checkKey"
             v-model="email" required />
      <input type="password"
             ref="password"
             placeholder="Senha"
             name="password"
             v-on:keypress="checkKey"
             v-model="password" required />
      <button
        ref="button"
        @click.prevent="login()">Autenticar</button>

      <router-link class="login-forget" :to="{ name: 'login.recover' }">
        Esqueci minha senha</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
    };
  },
  beforeCreate() {
    this.$store.commit('headerModeLogin');
  },
  mounted() {
    this.$refs.email.focus();
  },
  methods: {
    checkKey(event) {
      if (event.keyCode === 13) {
        if (event.target.name === 'password') {
          this.$refs.button.click();
          return;
        }
        this.$refs.password.focus();
      }
    },
    async login() {
      this.$store.commit('fetchActive');
      const { email, password } = this;
      if (email.length < 5 || password.length < 3) {
        this.$store.dispatch('addMessageDefault', 'Verifique os campos e tente novamente.');
        return;
      }
      await this.$store.dispatch('login', { email, password });
      this.$store.commit('fetchInactive');
    },
  },
};
</script>

<style scoped>
  .login{
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 60px;
  }
  .login-wrapper{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }
  img{
    height: 90px;
    object-fit: contain;
    margin-bottom: 60px;
  }
  .login-forget{
    margin-top: 100px;
  }
</style>
